// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"244":"648513d8","641":"30c13a5c","981":"8f3b0d65"}[chunkId] + ".css";
};